/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { carregarDistribuidores } from '../services/dists'

export const formatCpfCnpj = (value?: string) => {
  if (!value) return ''
  const num = value.replace(/\D/g, '')
  if (num.length === 11) return num.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4')
  if (num.length === 14) return num.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5')
  return value
}

export const parseSafeDate = (value: any): Date | null => {
  if (!value) return null
  if (value instanceof Date) return value
  const str = String(value).trim()

  // YYYYMMDD
  if (/^\d{8}$/.test(str)) {
    const y = parseInt(str.substring(0, 4))
    const m = parseInt(str.substring(4, 6)) - 1
    const d = parseInt(str.substring(6, 8))
    return new Date(y, m, d)
  }

  // YYYY-MM-DD ou YYYY/MM/DD
  const match = str.match(/^(\d{4})[-/](\d{2})[-/](\d{2})/)
  if (match) {
    return new Date(parseInt(match[1]), parseInt(match[2]) - 1, parseInt(match[3]))
  }

  // DD/MM/YYYY
  const matchBr = str.match(/^(\d{2})\/(\d{2})\/(\d{4})/)
  if (matchBr) {
    return new Date(parseInt(matchBr[3]), parseInt(matchBr[2]) - 1, parseInt(matchBr[1]))
  }

  const d = new Date(str)
  return isNaN(d.getTime()) ? null : d
}

export const formatDateBr = (value: any) => {
  if (!value && value !== 0) return ''
  const d = parseSafeDate(value)
  if (!d) return String(value)

  const day = String(d.getDate()).padStart(2, '0')
  const month = String(d.getMonth() + 1).padStart(2, '0')
  const year = d.getFullYear()
  return `${day}/${month}/${year}`
}

export const normalizeDateForComparison = (value: any): string => {
  const d = parseSafeDate(value)
  if (!d) return ''

  const year = d.getFullYear()
  const month = String(d.getMonth() + 1).padStart(2, '0')
  const day = String(d.getDate()).padStart(2, '0')
  return `${year}-${month}-${day}`
}

export const formatCurrencyBrr = (value: any) => {
  const n = value
  if (isNaN(n)) return value
  return n
}

export const formatCurrencyBr = (value: any) => {
  const n = Number(value)
  if (isNaN(n)) return value
  return n.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
}

export const formatUnidade = (value: any) => {
  const n = Number(value)
  if (isNaN(n)) return value
  return `${n}`
}

export const formatCaixa = (value: any) => {
  const n = Number(value)
  if (isNaN(n)) return value
  return `${n.toString().replace('.', ',')}`
}

export const getRegional = (uf: string) => {
  if (!uf) return ''

  const ufsRegional1 = [
    'AC',
    'AM',
    'AP',
    'MA',
    'PA',
    'PI',
    'RR',
    'RO',
    'TO',
    'AL',
    'BA',
    'CE',
    'MA',
    'PB',
    'PE',
    'RN',
    'SE',
  ]
  return ufsRegional1.includes(uf.trim().toUpperCase()) ? 'Regional 1' : 'Regional 2'
}

interface propsLoadDistribuidores {
  setDistribuidores: (data: any[]) => void
}
export const loadDistribuidores = async ({ setDistribuidores }: propsLoadDistribuidores) => {
  setDistribuidores(await carregarDistribuidores())
}

/**
 * Primeiro e último dia de um mês, em YYYY-MM-DD, para os parâmetros
 * `from`/`to` das rotas de coleção.
 *
 * Monta as strings por aritmética de número, sem passar por Date nem por
 * toISOString — é a armadilha de fuso descrita no CLAUDE.md, onde em UTC-3 o
 * dia 01 vira o dia 30 do mês anterior.
 *
 * `mesIndex` é 0-11, como o do MonthFilter.
 */
export const intervaloDoMes = (ano: number, mesIndex: number) => {
  const mes = String(mesIndex + 1).padStart(2, '0')
  // dia 0 do mês seguinte é o último dia do mês pedido
  const ultimoDia = new Date(ano, mesIndex + 1, 0).getDate()
  return {
    from: `${ano}-${mes}-01`,
    to: `${ano}-${mes}-${String(ultimoDia).padStart(2, '0')}`,
  }
}

